import { FunctionComponent, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconLabel } from '../../IconLabel';

import classes from './EventItemUnavailable.module.scss';

export const EventItemUnavailable: FunctionComponent = memo(() => {
  const { t } = useTranslation('', { keyPrefix: 'eventItem' });

  return (
    <div className={classes['event-item-unavailable']}>
      <IconLabel iconId={'event'} iconSize={20} nonClickable singleColor />
      <span className={classes['event-item-unavailable__text']}>{t('unavailable')}</span>
    </div>
  );
});
